module.exports = __webpack_public_path__ + "img/1.7c8347f6.png";